import script from "./CardVideoComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./CardVideoComponent.vue?vue&type=script&setup=true&lang=js"

import "./CardVideoComponent.vue?vue&type=style&index=0&id=1346322d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1346322d"]])

export default __exports__